import { Button } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { Alert } from '@material-ui/lab';
import React from 'react';
import strftime from 'strftime';
import { store } from '../constants/globals';
import { processInvoiceJSON, getStateForArrivalUpdate } from '../helpers/invoice_helpers';
import { resDetails } from '../helpers/reservation_helpers';
import ApiRequest from '../libs/ApiRequest';
import { InvoiceApiResp, isErrorResponse } from '../types/json_types';
import { isPresent } from '../util/util';
import AppDatePicker from './util/AppDatePicker';

const { setState, setPartialState, getNonNullState, useNonNullState: useArrivalState } = store.getHelpers(
  'update_arrival_page',
);

const clickUpdate = (): void => {
  const { arrival_date_at, invoice_token } = getNonNullState();

  if (!arrival_date_at) {
    alert('please select your arrival date');
    return;
  }

  const req = new ApiRequest(
    `/store_api/reservations/${invoice_token}.json`,
    'PATCH',
    {
      onSuccess: (resp: unknown): void => {
        const json = resp as InvoiceApiResp;
        const invoice = processInvoiceJSON(json.base.invoice, json.base.reservation);

        setPartialState({ invoice, success: true });
      },
      onError: (json: unknown): void => {
        if (isErrorResponse(json)) {
          alert(json.errors.join('&'));
        } else {
          alert(`couldnt find invoice with token ${invoice_token}`);
        }
      },
    },
    { reservation: { arrival_date_at } },
  );
  req.perform();
};

const renderSuccess = (date: Date): JSX.Element => {
  return (
    <div className="mt-3">
      <Alert severity="success">
        Success! You&apos;ve set your arrival date to {strftime('%B %o %Y', date)}
        <div className="mt-1">Thanks for letting us know!</div>
      </Alert>
    </div>
  );
};

export const UpdateArrival = (): JSX.Element => {
  const state = useArrivalState();

  const { invoice, invoice_token, arrival_date_at, working, success } = state;

  if (invoice) {
    const res = invoice.reservation;

    const { studentTxt, parentTxt, roomTxt } = resDetails(res);

    return (
      <div className="d-flex flex-column" style={{ maxWidth: 500, margin: 'auto' }}>
        <Typography variant="h6">Set your arrival date</Typography>
        <div className="p-1">
          <div>
            <b>Student: </b>
            {studentTxt}
          </div>
          {isPresent(roomTxt) && (
            <div>
              <b>Room: </b>
              {roomTxt}
            </div>
          )}
          <div>
            <b>Parent: </b>
            {parentTxt}
          </div>
        </div>

        <div className="my-2">
          <AppDatePicker
            date={arrival_date_at}
            style={{ width: '100%' }}
            onChangeDate={(d): void => {
              setPartialState({ arrival_date_at: d });
            }}
            label="What day will the student arrive on campus?"
          />
        </div>

        {success && arrival_date_at ? renderSuccess(arrival_date_at) : null}

        <div className="mt-3">
          <Button variant="outlined" color="primary" onClick={clickUpdate} disabled={working}>
            Update Arrival Date
          </Button>
        </div>
      </div>
    );
  } else {
    const req = new ApiRequest(`/store_api/get_invoice?token=${invoice_token}`, 'GET', {
      onSuccess: (resp: unknown): void => {
        const json = resp as InvoiceApiResp;
        const invoice = processInvoiceJSON(json.base.invoice, json.base.reservation);
        const state = getStateForArrivalUpdate(invoice_token, invoice);

        setState(state);
      },
      onError: (json: unknown): void => {
        if (isErrorResponse(json)) {
          alert(json.errors.join('&'));
        } else {
          alert(`couldnt find invoice with token ${invoice_token}`);
        }
      },
    });
    req.perform();

    return <div></div>;
  }
};
